export const theme = {
  colors: {
    primary: '#266c7f',    // Deep teal blue
    accent: '#ff8f31',     // Warm orange
    background: '#fffbf3',  // Off-white cream
    text: '#333333',       // Dark gray for text
    textLight: '#666666',  // Light gray for secondary text
    white: '#ffffff',      // Pure white
  },
  fonts: {
    primary: "'Inter', sans-serif",
    heading: "'Poppins', sans-serif",
  },
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1440px',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
    lg: '16px',
    full: '50%',
    round: '50%',
  },
  transitions: {
    default: '0.3s ease-in-out',
    fast: '0.2s ease-in-out',
    slow: '0.4s ease-in-out',
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.1)',
    large: '0 8px 16px rgba(0, 0, 0, 0.1)',
    glass: '0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
  },
};
